function getInitialTicketTypeQuantity(ticketType, ticketGroup) {
  if (ticketType.availabilityStatus !== 'available') {
    return 0;
  }

  if (ticketGroup.preselect?.enabled && ticketGroup.preselect.ticketType === ticketType._id) {
    if (ticketGroup.ticketSelectionType === 'quantity') {
      return ticketGroup.preselect?.quantity || 1;
    } else {
      return 1;
    }
  }

  return 0;
}

export function getTicketGroupsFormState(ticketGroups, query = {}) {
  if (!ticketGroups || !ticketGroups.length) return [];

  // set default values
  // return the preselected option if preselect is enabled
  const ticketGroupsFormState = ticketGroups.reduce((obj, ticketGroup) => {
    obj[ticketGroup._id] = ticketGroup.ticketTypes.map(ticketType => ({
      ticketTypeId: ticketType._id,
      quantity: getInitialTicketTypeQuantity(ticketType, ticketGroup),
    }));

    return obj;
  }, {});

  // match params to form field references
  Object.entries(query).forEach(([key, value]) => {
    const ticketGroup = ticketGroups.find(ticketGroup => ticketGroup.reference === key);

    if (ticketGroup) {
      const ticketType = ticketGroup.ticketTypes.find(ticketType => ticketType.reference === value);

      if (ticketType) {
        ticketGroupsFormState[ticketGroup._id] = [
          {
            ticketTypeId: ticketType._id,
            quantity: 1,
          },
        ];
      }
    }
  });

  return ticketGroupsFormState;
}
